import { InjectedConnector } from './Injected'
import { NetworkConnector } from './NetworkConnector'
import { RPC_URL, SUPPORTED_CHAIN_ID } from '../chainConfig'

const NETWORK_URL = RPC_URL

if (typeof NETWORK_URL === 'undefined') {
  throw new Error(`REACT_APP_NETWORK_URL must be a defined environment variable`)
}

export const network = new NetworkConnector({
  urls: { [SUPPORTED_CHAIN_ID]: NETWORK_URL }
})

export const injected = new InjectedConnector({
  supportedChainIds: [SUPPORTED_CHAIN_ID]
})
